import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import StarPicker from "./StarPicker";
import importantElements from "../../assets/important-elements";

function WhatsImportant(props) {
    const {store, color} = props;

    let group = 'important';
    return (
        <div className={'WhatsImportant'}>
            <div className={'picker-intro'}>

                <h4>Which of these six themes are most important to you?</h4>

                <p>These themes summarize core goals for the campus plan and will inform future planning decisions, from open space networks, to academic life recommendations, to building renovations, and infrastructure investments.</p>
                <p>Distribute {store.persistStore.getTotalCoins(group)} coins across the {importantElements.length} themes below -- more coins means higher priority.</p>

            </div>
            <div className={'remaining'}>Remaining coins: {store.persistStore.getRemainingCoins(group)}</div>
            <div className={'picker-list'}>
                {importantElements.map((v, i) => <div key={`op_${v.id}`}
                                                      style={{background: color}}
                                                      className={'prog-item'}>
                    <div>{v.name}</div>
                    <StarPicker group={group} store={store} id={v.id} total={5}/>
                </div>)}
            </div>
        </div>
    );
}

export default observer(WhatsImportant);
